<template>
  <Swiper
    :modules="modules"
    :slides-per-view="1"
    :space-between="0"
    :loop="true"
    :grab-cursor="true"
    :speed="600"
    :effect="'fade'"
    :class="$style.swiper"
  >
    <SwiperSlide v-for="(item, idx) in data" :key="idx">
      <MediaBlockItem :data="item" :idx="idx" :layout="layout" />
    </SwiperSlide>
    <SwiperNav class="absolute bottom-0 right-0 top-auto z-20" />
  </Swiper>
</template>

<script setup lang="ts">
import { Parallax, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import type { FileField } from '~/types/datocms'

import 'swiper/css'

defineProps<{
  data: FileField
  layout: 'grid' | 'collage' | 'slider'
}>()

const modules = [Parallax, A11y]
</script>

<style lang="postcss" module>
.swiper {
  @apply relative mx-auto h-auto w-full;
}
</style>

<style lang="postcss">
.swiper-pagination-bullet {
  --swiper-pagination-bullet-width: 8px;
  --swiper-pagination-bullet-size: 8px;
  --swiper-pagination-bullet-inactive-color: theme(colors.primary);
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-bullet-horizontal-gap: 0;
  --swiper-pagination-bullet-inactive-opacity: 1;
  border-radius: 0;
  margin: 0 2px !important;
}

.swiper-pagination-bullet-active {
  background: theme(colors.black);
}
</style>
